import React from "react"
import { Container, Row, Col, Button, Form, Card } from "react-bootstrap"
import { Formik, Field, ErrorMessage } from "formik"
import * as Yup from "yup"
import { getResponseChoice, patchResponseChoice, postResponseChoice } from "../../api/api_response_choice"
import { cleanEntity } from "../../Common/js/clean_entity"
import Select from "react-select"
import withHooks from "../../Common/jsx/WithHooks"
import { FR, GB } from "country-flag-icons/react/3x2"
import { ucFirst } from "../../Common/js/generic_functions"
import { ENDPOINT_QUESTIONS, getQuestions } from "../../api/api_question"

class ResponseChoiceForm extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    // this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    // CONFIG ==================================================================================================
    let emptyEntity = {
      responseFr: "",
      justificationFr: "",
      responseEn: "",
      justificationEn: "",
    }
    // /CONFIG =================================================================================================

    let entity
    let isReadyToRender
    if (this.props.entityId === undefined) {
      this.formType = "create"
      this.cardHeaderText = this.props.t("action.adding") + " " + this.props.t("entity." + this.props.entityType)
      entity = emptyEntity
      isReadyToRender = true
    } else {
      this.formType = "edit"
      this.cardHeaderText = this.props.t("action.editing") + " " + this.props.t("entity." + this.props.entityType) + " #" + this.props.entityId
      isReadyToRender = false
    }
    this.dMgr.debug("formType:", this.formType)

    this.state = {
      isReadyToRender: isReadyToRender,
      disable_button_validate: false,
      entity: entity,
      // CONFIG ==================================================================================================
      questions: [],
      // /CONFIG =================================================================================================
    }
    this.dMgr.debug("init_state:", this.state)

    this.getEntity = this.getEntity.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.lockAndSubmit = this.lockAndSubmit.bind(this)
    this.getRelatedEntities = this.getRelatedEntities.bind(this)
    this.getFormValidationSchema = this.getFormValidationSchema.bind(this)
  }

  componentDidMount() {
    this.getEntity()
    this.getRelatedEntities()
  }

  async getEntity() {
    if (this.props.entityId !== undefined) {
      // CONFIG ==================================================================================================
      let entity = await getResponseChoice(this.props.entityId)
      // /CONFIG =================================================================================================
      this.dMgr.debug("getEntity:", entity)
      this.setState({ entity, isReadyToRender: true })
    }
  }

  getRelatedEntities() {
    // CONFIG ==================================================================================================
    Promise.all([getQuestions()]).then((promisesResults) => {
      let [questions] = promisesResults

      this.dMgr.debug("getRelatedEntities done")
      this.setState({
        questions: questions["hydra:member"],
        // questionsAsObject: getObjectIdKey(questions["hydra:member"]),
      })
    })
    // /CONFIG =================================================================================================
  }

  getFormValidationSchema() {
    // CONFIG ==================================================================================================
    return Yup.object().shape({
      responseFr: Yup.string().required(this.props.t("message.required")),
      responseEn: Yup.string().required(this.props.t("message.required")),
    })
    // /CONFIG =================================================================================================
  }

  async lockAndSubmit(values, { setSubmitting }) {
    this.dMgr.debug("lockAndSubmit:", values)
    this.setState({ disable_button_validate: true }, () => this.handleSubmit(values, { setSubmitting }))
  }

  async handleSubmit(values, { setSubmitting }) {
    this.dMgr.debug("handleSubmit:", values)

    try {
      // CONFIG ==================================================================================================

      let entity = cleanEntity(values)
      entity.question = ENDPOINT_QUESTIONS + "/" + entity.question.id

      let newEntity = {}
      if (entity.id === undefined) {
        this.dMgr.debug("post entity:", entity)
        newEntity = await postResponseChoice(entity)
      } else {
        this.dMgr.debug("patch entity:", entity.id, entity)
        newEntity = await patchResponseChoice(entity.id, entity)
      }

      this.dMgr.debug("success entity:", newEntity.id, newEntity)
      this.props.notif.success()
      this.props.router.nav({
        prefix: "admin",
        entitiesType: this.props.entitiesType,
      })
      // /CONFIG =================================================================================================
    } catch (err) {
      this.dMgr.error("COUGHT EXCEPTION:", err)
      this.props.notif.failed(err)
    } finally {
      this.setState({ disable_button_validate: false })
      setSubmitting(false)
    }
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    let toRender = (
      <Container>
        <Formik enableReinitialize initialValues={this.state.entity} validationSchema={this.getFormValidationSchema} onSubmit={this.lockAndSubmit}>
          {({ handleSubmit, handleChange, values, touched, errors, setFieldValue }) => (
            <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
              {/* {console.log("Formik values:", values)}
              {console.log("Formik errors:", errors)}
              {console.log("Formik touched:", touched)} */}
              <Row>
                <Col md={3}></Col>
                <Col md={6}>
                  <Card className="bg-dark text-white box-shadow-lvl3">
                    <Card.Header>{this.cardHeaderText}</Card.Header>
                    <Card.Body>
                      {/* CONFIG ==================================================================================== */}
                      <Container fluid>
                        <Row>
                          <Col md={1}>
                            <FR title="Français" className="lang_flag" />
                          </Col>
                          <Col md={11}>
                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8">
                                <Form.Label>{this.props.t("form.response") + this.props.t("app.dbp")}</Form.Label>
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formResponseFr">
                                  <Field as={Form.Control} name="responseFr" isInvalid={touched.responseFr && errors.responseFr} onChange={handleChange} value={values.responseFr} />
                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="responseFr" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 ">
                                <Form.Label>{this.props.t("form.justification") + this.props.t("app.dbp")}</Form.Label>
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formJustificationFr">
                                  <Field
                                    as={Form.Control}
                                    name="justificationFr"
                                    isInvalid={touched.justificationFr && errors.justificationFr}
                                    onChange={handleChange}
                                    value={values.justificationFr}
                                  />
                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="justificationFr" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <br />
                        <Row>
                          <Col md={1}>
                            <GB title="English" className="lang_flag" />
                          </Col>
                          <Col md={11}>
                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8">
                                <Form.Label>{this.props.t("form.response") + this.props.t("app.dbp")}</Form.Label>
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formResponseEn">
                                  <Field as={Form.Control} name="responseEn" isInvalid={touched.responseEn && errors.responseEn} onChange={handleChange} value={values.responseEn} />
                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="responseEn" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 ">
                                <Form.Label>{this.props.t("form.justification") + this.props.t("app.dbp")}</Form.Label>
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formJustificationEn">
                                  <Field
                                    as={Form.Control}
                                    name="justificationEn"
                                    isInvalid={touched.justificationEn && errors.justificationEn}
                                    onChange={handleChange}
                                    value={values.justificationEn}
                                  />
                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="justificationEn" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 "></Col>
                              <Col md={9}>
                                <Form.Group controlId="formIsCorrect">
                                  <Form.Check
                                    id="isCorrect"
                                    name="isCorrect"
                                    type="checkbox"
                                    label={this.props.t("form.isCorrect")}
                                    checked={values.isCorrect}
                                    onChange={(e) => {
                                      setFieldValue("isCorrect", e.target.checked)
                                    }}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 ">
                                <Form.Label>{this.props.t("form.question") + this.props.t("app.dbp")}</Form.Label>
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formQuestion">
                                  <Select
                                    id="input_select_question"
                                    classNamePrefix="custom-react-select"
                                    // placeholder={this.props.t("form.question")}
                                    className={`react-select ${touched.questionType && errors.questionType ? "react-select-invalid" : ""}`}
                                    name="question"
                                    options={this.state.questions
                                      .filter((question) => {
                                        return question.isVisible
                                      })
                                      .sort((a, b) => {
                                        if (a["statement" + ucFirst(this.props.i18n.resolvedLanguage)] < b["statement" + ucFirst(this.props.i18n.resolvedLanguage)]) {
                                          return -1
                                        }
                                        if (a["statement" + ucFirst(this.props.i18n.resolvedLanguage)] > b["statement" + ucFirst(this.props.i18n.resolvedLanguage)]) {
                                          return 1
                                        }
                                        return 0
                                      })
                                      .map((question) => {
                                        return {
                                          value: question,
                                          label: <>{question.id + " - " + question["statement" + ucFirst(this.props.i18n.resolvedLanguage)]}</>,
                                        }
                                      })}
                                    defaultValue={
                                      values.question !== undefined
                                        ? {
                                            value: values.question,
                                            label: values.question.id + " - " + values.question["statement" + ucFirst(this.props.i18n.resolvedLanguage)],
                                          }
                                        : ""
                                    }
                                    onChange={(e) => {
                                      setFieldValue("question", e.value)
                                    }}
                                  />

                                  {touched.question && errors.question && <div className="invalid-feedback d-block">{errors.question}</div>}
                                </Form.Group>
                              </Col>
                            </Row>
                          </Col>
                        </Row>

                        <br />
                        <Row>
                          <Col md={4}></Col>
                          <Col md={2} className="text-center">
                            <Button
                              id="btn-cancel"
                              onClick={() =>
                                this.props.router.nav({
                                  url: this.props.router.location.state.referrerUrl,
                                })
                              }
                              variant="secondary"
                              size="sm"
                              className="margin-right-5"
                            >
                              {this.props.t("action.cancel")}
                            </Button>
                          </Col>
                          <Col md={2} className="text-center">
                            <Button id="btn-submit" variant="primary" size="sm" type="submit" disabled={this.state.disable_button_validate} className="margin-right-5">
                              {this.props.t("action.validate")}
                            </Button>
                          </Col>
                        </Row>
                      </Container>
                      {/* /CONFIG ================================================================================ */}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Container>
    )

    this.dMgr.renderDone()
    return toRender
  }
}

export default withHooks(ResponseChoiceForm)
